import { useState, useEffect } from 'react';
import consent from '@buzzfeed/consent';

const {
  framework,
  rules
} = consent;
function useConsent() {
  let action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'tracking';
  const needsConsent = framework.needsConsent();
  /**
   * On server render, need for consent will never be known (relies on window and browser cookies)
   *  If on client, consent can be considered 'known' from the start if determined it is not needed
   */
  const [isConsentKnown, setIsConsentKnown] = useState(!needsConsent || framework.isConsentStringCookieSet());
  const [isConsentReady, setIsConsentReady] = useState(!needsConsent);
  const [consentValue, setConsentValue] = useState(!needsConsent);
  useEffect(() => {
    const checkConsent = async () => {
      const value = await rules.hasConsented(action);
      setConsentValue(value);
      setIsConsentKnown(true);
      setIsConsentReady(true);
    };
    if (needsConsent) {
      checkConsent();
    }
  }, [action, needsConsent]);
  return {
    consentValue,
    isConsentKnown,
    isConsentReady
  };
}

export { useConsent as default };
